/* nexusProvider.ts */
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import nexusClient from './nexusClient';

Vue.use(VueApollo);

const nexusProvider = new VueApollo({
  defaultClient: nexusClient as any // Cast to avoid VueApollo type mismatch with Apollo Client v3
});

export default nexusProvider;
